import { apiClient } from './api-client';
import { Message, CreateMessageRequest } from '../types';

export class MessageService {
  // Get user messages/conversations
  async getMessages(filters?: { 
    isRead?: boolean; 
    isArchived?: boolean; 
    limit?: number; 
  }): Promise<Message[]> {
    const params = new URLSearchParams();
    if (filters?.isRead !== undefined) params.append('isRead', filters.isRead.toString());
    if (filters?.isArchived !== undefined) params.append('isArchived', filters.isArchived.toString());
    if (filters?.limit) params.append('limit', filters.limit.toString());

    const response = await apiClient.get(`/api/messages?${params}`);
    return response.success ? response.data : [];
  }

  // Get unread message count
  async getUnreadCount(): Promise<number> {
    const response = await apiClient.get('/api/messages/unread-count');
    return response.success ? (response.count || 0) : 0;
  }

  // Send new message
  async sendMessage(message: CreateMessageRequest): Promise<boolean> {
    const response = await apiClient.post('/api/messages', message);
    return response.success;
  }

  // Mark message as read
  async markAsRead(messageId: string): Promise<boolean> {
    const response = await apiClient.put(`/api/messages/${messageId}/read`);
    return response.success;
  }

  // Archive message
  async archiveMessage(messageId: string): Promise<boolean> {
    const response = await apiClient.put(`/api/messages/${messageId}/archive`);
    return response.success;
  }

  // Get conversation between two users
  async getConversation(otherUserId: string): Promise<Message[]> {
    const response = await apiClient.get(`/api/messages/conversation/${otherUserId}`);
    return response.success ? response.data : [];
  }
}

export const messageService = new MessageService();